const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/pages/appointment/components/CommentField.tsx';
import { TextField, Typography } from '@mui/material';
import textMap from 'App/pages/appointment/translations';
import { AriaLabelType, Label } from 'App/components/old_components/components/Label';
import React from 'react';
import { css } from '@emotion/css';
import { colors } from '@cistec/common_web/defs/colors';
import { useIntl } from 'react-intl';

interface Props {
    defaultValue?: string;
    onChange: (event: any) => void;
    error: string;
    required?: boolean;
}

const cssCommentFieldWrapper = css`
    display: flex;
    flex-direction: column;
`;
const cssCommentLabelWrapper = css`
    display: flex;
    justify-content: space-between;
    color: ${colors.grey['600']};
`;

const cssHelpTextIconButton = css`
    & > button {
        top: -18px;
    }
`;

const cssList = css`
    padding-left: 20px;

    & li {
        margin-bottom: 18px;
    }
`;

const renderAsList = (text: string) => (
    <ul className={cssList}>
        {text.split('\n').map(line => (
            <li key={line}>{line}</li>
        ))}
    </ul>
);

export const CommentField = (props: Props) => {
    const { defaultValue, onChange, error } = props;
    const required = props.required || false;

    const { formatMessage } = useIntl();

    return (
        <div className={cssCommentFieldWrapper}>
            <div className={cssCommentLabelWrapper}>
                <Typography variant="body1">
                    {formatMessage(textMap.label)}
                    {required ? ' *' : null}
                </Typography>
                <Label
                    text={''}
                    aria={AriaLabelType.useText}
                    icon={'help'}
                    compTitle={textMap.helpTitleText}
                    isFormView={false}
                    helpText={renderAsList(formatMessage(textMap.helpText))}
                    className={cssHelpTextIconButton}
                />
            </div>
            <TextField
                required={required}
                slotProps={{ htmlInput: { maxLength: 500 } }}
                multiline
                rows={4}
                defaultValue={defaultValue}
                onChange={onChange}
                error={!!error}
                helperText={error}
            />
        </div>
    );
};
